import { render } from "./Representation.vue?vue&type=template&id=4bade2d6"
import script from "./Representation.vue?vue&type=script&lang=js"
export * from "./Representation.vue?vue&type=script&lang=js"

import "./Representation.vue?vue&type=style&index=0&id=4bade2d6&lang=css"
script.render = render

export default script